exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3GGAjarae5eagIzfBMT_tY{padding:30px 40px 40px 40px}@media screen and (max-width: 700px){._3GGAjarae5eagIzfBMT_tY{padding:20px 10px}}._1-7CTomQLLkZ1YcKbLX_RI{text-align:center;padding:50px 40px 40px 40px}._1-7CTomQLLkZ1YcKbLX_RI a{max-width:200px;display:inline-block}._29ncuerhBRk2hT5ns21a9T{padding-top:35px}._3q5S0g12jC3z8BV188yClc{max-width:720px;margin:0px auto 40px auto;display:block}\n", ""]);

// Exports
exports.locals = {
	"EmptyRoutes": "_3GGAjarae5eagIzfBMT_tY",
	"mainCard": "_1-7CTomQLLkZ1YcKbLX_RI",
	"buildYourRide": "_29ncuerhBRk2hT5ns21a9T",
	"leadText": "_3q5S0g12jC3z8BV188yClc"
};